export default __webpack_public_path__ + "static/N0108-177ce1bf84bef78078e00ce7a2a53428.png";